export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined) ||
  "https://allchinabuyspread.team";

export const SITE_NAME = "AllChinaBuy Spreadsheet";

export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg";

export const SITE_LANGUAGES = ["en", "fr", "de", "da"];